export const isImage = (url: string) => {
  return /\.(jpe?g|png|gif|bmp|tiff|webp|svg)$/.test(url);
};
